import { Instagram, Facebook } from "lucide-react";
import { Reveal } from "./Reveal";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, FACEBOOK_URL } from "../data/content";

export const InstagramFeed = () => (
  <section id="instagram" className="bg-cream py-20 md:py-28" data-testid="instagram-section">
    <div className="container-x">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-beige px-8 py-14 text-center md:px-16 md:py-20 grain">
          <span className="eyebrow">Seguici sui social</span>
          <h2 className="h2 mt-4">#BiovitalBeauty</h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-muted">
            Novità, trattamenti del momento e piccoli rituali di bellezza quotidiana: seguici per restare aggiornata su tutto ciò che accade in centro.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="btn-sage" data-testid="instagram-follow-btn">
              <Instagram className="h-4 w-4" /> {INSTAGRAM_HANDLE}
            </a>
            <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" className="btn-outline text-sage hover:bg-sage hover:text-white" data-testid="facebook-follow-btn">
              <Facebook className="h-4 w-4" /> Centro Estetico Benessere Biovital
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
